import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { ArticleType } from '@atlassian/jira-servicedesk-knowledge-services/src/types';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';

export const FETCH_ARTICLE = 'state.actions.fetch-article.FETCH_ARTICLE' as const;

export type FetchArticleAction = {
	type: typeof FETCH_ARTICLE;
	payload: {
		id: string;
		articleType: ArticleType;
		accountId: AccountId | null;
		createAnalyticsEvent: CreateUIAnalyticsEvent;
	};
};

export const fetchArticle = (
	id: string,
	articleType: ArticleType,
	accountId: AccountId | null,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
): FetchArticleAction => ({
	type: FETCH_ARTICLE,
	payload: {
		id,
		articleType,
		accountId,
		createAnalyticsEvent,
	},
});
